// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { bindTrainingHub } from "../../../svelte/src/bindings/training-hub.js";

import { initializeGeneralUtils } from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { initializeSidebar } from "../../../svelte/src/bindings/sidebar.js";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications.js";
import { initializeTraining } from "../src/dropdown/training.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeCleartext } from "../src/general/elements/cleartext.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeWins } from "../src/wins/wins.js";

bindTestPanel();
bindSystemBannerNotifications();
initializeTheme();
initializeConfig();
initializeGeneralUtils();
initializeVisibilities();
initializeSidebar();
initializeCleartext();
initializeTracking();
initializeWins();
userStore.once().then((user) => {
  if (!user) return; // 401
  if (user.trainingHubStatus) {
    bindTrainingHub();
    $("#main-container").remove();
    $("#content").removeClass("skeleton-loading");
  } else {
    $("#main-container").removeClass("d-none");
    $("#content").removeClass("skeleton-loading");
    initializeTraining();
  }
});
